export default {
  LIST_ATTENDENCE_FOR_STUDENT_REQUEST: "LIST_ATTENDENCE_FOR_STUDENT_REQUEST",
  LIST_ATTENDENCE_FOR_STUDENT_SUCCESS: "LIST_ATTENDENCE_FOR_STUDENT_SUCCESS",
  LIST_ATTENDENCE_FOR_STUDENT_FAIL: "LIST_ATTENDENCE_FOR_STUDENT_FAIL",

  DELETE_ATTENDENCE_REQUEST: "DELETE_ATTENDENCE_REQUEST",
  DELETE_ATTENDENCE_SUCCESS: "DELETE_ATTENDENCE_SUCCESS",
  DELETE_ATTENDENCE_FAIL: "DELETE_ATTENDENCE_FAIL",

  ATTENDENCE_LOADING: "ATTENDENCE_LOADING",
};
